import { readersJSON, readersUrl } from './ReadersAPI';
import { ApiError, dashboardJSON } from './api';
import { ActivitySummary, Paged, ReaderActivity, ReaderDetail, ReaderRow, ReaderStats } from '../Models/AdminUsers';

export type ReaderQuery = {
  page: number;
  limit: number;
  search: string;
  type: string;
  plan: string;
  activity: string;
  from: string;
  to: string;
  sort: string;
  dir: 'asc' | 'desc';
  site?: string;
  read?: string;
  finished?: string;
};

// Reading users and activity come from nftserver (/api/readers-admin), which reads the Readers database
// directly, so no separate Readers sign in is needed.
export const fetchReaders = (query: ReaderQuery, signal: AbortSignal) =>
  dashboardJSON<Paged<ReaderRow>>('/api/readers-admin/list', query, { signal });

export const fetchReaderStats = (signal: AbortSignal) => dashboardJSON<ReaderStats>('/api/readers-admin/stats', {}, { signal });

export const fetchReader = async (id: string, signal: AbortSignal) =>
  (await dashboardJSON<{ user: ReaderDetail }>(`/api/readers-admin/${id}`, {}, { signal })).user;

export const createCouponCode = (code: string, duration: string) =>
  readersJSON<{ message: string }>(readersUrl('/api/payments/createCode'), {
    method: 'POST',
    body: JSON.stringify({ code, duration }),
  });

/** null when the Readers server does not have the activity API yet (404), so pages show the empty state. */
const nullOn404 = async <T>(request: Promise<T>): Promise<T | null> => {
  try {
    return await request;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
};

export const fetchActivitySummary = (days: number, signal: AbortSignal) =>
  nullOn404(dashboardJSON<ActivitySummary>('/api/readers-admin/activity/summary', { days }, { signal }));

export const fetchReaderActivity = (id: string, signal: AbortSignal, limit = 200) =>
  nullOn404(dashboardJSON<ReaderActivity>(`/api/readers-admin/${id}/activity`, { limit }, { signal }));
